export function getContainerWidthFromText (text, fontSize, padding) {
  let span = document.createElement('span')
  span.style.visiblity = 'hidden'
  span.style.fontFamily = 'Roboto'
  span.style.padding = padding || '0'
  span.innerHTML = text
  span.style.fontSize = fontSize
  document.body.appendChild(span)
  let width = span.offsetWidth * 2
  console.log(width)
  document.body.removeChild(span)
  return width
}



// WEBPACK FOOTER //
// ./src/Services/styleHelper.js